import uuid from 'react-uuid';
import jwt from 'jsonwebtoken';
import { getToken } from '../auth/AuthActions';

export const BID_PLACED = 'BID_PLACED';

const SSE_URL = process.env.REACT_APP_SSE_URL || '';
const DEVICE_ID = 'DEVICE_ID';

const getDeviceId = () => {
  let deviceId = sessionStorage.getItem(DEVICE_ID);
  if (deviceId) {
    return deviceId;
  }

  deviceId = uuid();
  sessionStorage.setItem(DEVICE_ID, deviceId);
  return deviceId;
};

export class SSEClient {
  constructor(type) {
    this.client = null;
    this.type = type;
  }

  listen(callback) {
    const token = getToken();
    const decodedToken = jwt.decode(token);

    this.close();
    const deviceId = getDeviceId();
    const query = `_st=${decodedToken?._st}&deviceId=${deviceId}`;

    this.client = new EventSource(`${SSE_URL}/sse/auction/admin?${query}`);

    const getEventData = (e) => {
      callback(JSON.parse(e.data));
    };

    this.client.addEventListener(BID_PLACED, (e) => getEventData(e), false);
  }

  close() {
    if (this?.client) {
      this.client.close();
      this.client = null;
    }
  }
}
